/*
 * Header cart count badge.
 *
 * The theme never publishes its cartUpdate pub/sub event, but cart-element
 * rewrites the class on every [data-cart-drawer-toggle] whenever the cart
 * changes. Watching that attribute is a reliable update signal and avoids
 * patching the minified theme.js. Every badge on the page shares a single
 * debounced /cart.js request.
 */

(function () {
  var MAX_DISPLAYED = 9;
  var badges = new Set();
  var refreshTimer = null;

  function paint(count) {
    var label = count > MAX_DISPLAYED ? MAX_DISPLAYED + '+' : String(count);

    badges.forEach(function (badge) {
      badge.textContent = label;
    });
  }

  function refresh() {
    if (refreshTimer) return;

    refreshTimer = setTimeout(function () {
      refreshTimer = null;

      var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';

      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (cart) paint(cart.item_count);
        })
        .catch(function () {
          // Leave the server-rendered count in place.
        });
    }, 50);
  }

  class CartCountBadge extends HTMLElement {
    connectedCallback() {
      badges.add(this);

      var toggle = this.closest('.cart__toggle');
      if (!toggle) return;

      this.observer = new MutationObserver(refresh);
      this.observer.observe(toggle, { attributes: true, attributeFilter: ['class'] });
    }

    disconnectedCallback() {
      badges.delete(this);

      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('cart-count-badge')) {
    customElements.define('cart-count-badge', CartCountBadge);
  }
})();
